export const WHERE_TO = "Where to?";
export const WHERE_FROM = "Where from?";
export const RETURN = "Return";
export const DEPARTURE = "Departure";
export const SEARCH_AGAIN = "Search Again";
export const SELECT_DATES = "Select";
